import { action } from 'easy-peasy';
import { IActionSetCrisisCalls } from '../types';

const setCrisisCalls: IActionSetCrisisCalls = action((state, payload) => {
  state.crisisCalls = payload;
});

export default setCrisisCalls;
